export enum LocationType {
  Region = 'region',
  Country = 'country',
  State = 'state',
  City = 'city',
  District = 'district'
}
